import { render, staticRenderFns } from "./AppLauncherVersions.vue?vue&type=template&id=626baa40&scoped=true"
import script from "./AppLauncherVersions.vue?vue&type=script&lang=ts"
export * from "./AppLauncherVersions.vue?vue&type=script&lang=ts"
import style0 from "./AppLauncherVersions.vue?vue&type=style&index=0&id=626baa40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.31_css-loader@7.1.4_webpack@5.105.4__ejs@3.1.10_hand_ylukk2m4i5f72bin4t3vwj3wvq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626baa40",
  null
  
)

export default component.exports